import { EntityQueue, EntityQueueAppearanceTone, EntityQueueType } from '@jms/model';

export interface ResolvedQueueAppearance {
  icon: string;
  tone: EntityQueueAppearanceTone;
}

const DEFAULT_FLAG_ICON = 'fa-regular fa-flag';
const DEFAULT_ENTITY_ICON = 'fa-regular fa-layer-group';
const DEFAULT_TONE: EntityQueueAppearanceTone = 'gray';

export function resolveQueueAppearance(queue: Partial<EntityQueue> | null | undefined): ResolvedQueueAppearance {

  const icon = queue?.appearance?.icon || (queue?.type === EntityQueueType.Flag ? DEFAULT_FLAG_ICON : DEFAULT_ENTITY_ICON);
  const tone = queue?.appearance?.tone ?? DEFAULT_TONE;
  return { icon, tone };
}
